import React from 'react';
import * as classes from './HeroSectionLinks.module.scss';
import GalleryIcon from '../../../../../assets/icons/inline/gallery.inline.svg';
import BoxIcon from '../../../../../assets/icons/inline/box-blue.inline.svg';
import MessageIcon from '../../../../../assets/icons/inline/messages.inline.svg';
import ClipboardIcon from '../../../../../assets/icons/inline/clipboard.inline.svg';
import Link from '../../../../Common/Link/Link';
import cn from 'classnames';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const HeroSectionLinks = () => {
  const { t } = useTranslation();
  return (
    <div className={classes.wrapper} data-aos='fade-in' data-aos-delay='500'>
      <div className={classes.title}>{t('homePage.heroSection.linksTitle')}</div>
      <div className='row'>
        <div className='col-6'>
          <Link path={t('header.menu.services.url')} className={cn(classes.navItem, classes.red)}>
            <ClipboardIcon />
            <div>{t('header.menu.services.label')}</div>
          </Link>
        </div>
        <div className='col-6'>
          <Link path={t('header.menu.additionalInfo.url')} className={cn(classes.navItem, classes.blue)}>
            <BoxIcon />
            <div>{t('header.menu.additionalInfo.label')}</div>
          </Link>
        </div>
        <div className='col-6'>
          <Link path={t('header.menu.gallery.url')} className={cn(classes.navItem, classes.yellow)}>
            <GalleryIcon />
            <div>{t('header.menu.gallery.label')}</div>
          </Link>
        </div>
        <div className='col-6'>
          <Link path={t('header.menu.getInTouch.url')} className={cn(classes.navItem, classes.violet)}>
            <MessageIcon />
            <div>{t('header.menu.getInTouch.label')}</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HeroSectionLinks;
